import { Component, Input, OnInit, inject } from '@angular/core';
import { BaseComponent, WmsTypeaheadComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, WmsMessageComponent } from '@wms/app/components';
import { SecurityService } from '@wms/settings/security';
import {cloneDeep, find, includes, isEqual, remove, toLower} from 'lodash-es';
import { OrderByPipe } from '@wm/components-base';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RoleSelectorComponent } from '@wms/app/properties-panel';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.less'],
  imports: [OrderByPipe, FormsModule, CommonModule, WmsTypeaheadComponent, RoleSelectorComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsMessageComponent]
})
export class DemoComponent extends BaseComponent implements OnInit {
  @Input() securityProps: any;
  @Input() authInfo: any;
  securityService: SecurityService
  security: any;
  error: any = {};
  initialDemoUsers: any;
  resetFormSubscription: Subscription;
  sortedRolesList:any
  constructor() {
    super();
    this.securityService = inject(SecurityService);
  }

  ngOnInit(): void {
    this.security = this.securityService.security;
    this.initConfig('DEMO');
    this.security.landingPage = 'Main';
    //get demo roles from backend
    // TODO
    // $s.showSpinner();
    this.sortedRolesList = [...this.security.roles].sort((a:any, b:any) => a.toString().localeCompare(b.toString()));
    this.initialDemoUsers = cloneDeep(this.security.demoUsers);

    this.security.demoUsers.sort((a: { username: string; }, b: { username: any; }) => a.username.localeCompare(b.username));
    this.resetFormSubscription = this.securityService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.security.demoUsers = cloneDeep(this.initialDemoUsers);
      } else {
        this.initialDemoUsers = cloneDeep(this.security.demoUsers);
      }
    });
  }

  onRoleChange($event: any, user: any) {
    this.securityService.hideMessage(true);
    user.roles = $event;
    if (!$event.length) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_SELECT_ATLEAST_ONE_ROLE'],'error');
    }
  }

  handleModelChange($event: any) {
    this.security.demoUserRole = $event.value;
  }

  //adds a demo user to existing demoUsers list
  addDemoUser() {
    if (!this.security.enableSecurity) {
      return;
    }

    let username = toLower(this.security.demoUsername),
      password = this.security.demoUserPassword,
      role = this.security.demoUserRole ? [this.security.demoUserRole] : [],
      error = {},
      i;

    this.error = error;
    this.securityService.hideMessage(true);

    if (!username) {
      //to show error icon in username input field
      this.error.uError = true;
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_ENTER_USERNAME,'error');
      return;
    }

    if (!password) {
      //to show error icon in password input field
      this.error.pError = true;
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_ENTER_PASSWORD,'error');
      return;
    }

    if (!role.length) {
      //to show error icon in password input field
      this.error.rError = true;
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_CHOOSE_APP_ROLE,'error');
      return;
    }

    if (this.security.demoUsers) {
      for (i = this.security.demoUsers.length - 1; i >= 0; i -= 1) {
        if (username === toLower(this.security.demoUsers[i].username)) {
          this.error.uError = true;
          this.securityService.hideMessage(false);
          this.securityService.showMessage(this.locale.MESSAGE_USER_ALREADY_EXISTS,'error');
          return;
        }
      }
    }

    // to save the username (entered by user) without lower casing it.
    username = this.security.demoUsername;
    this.security.demoUsers.push({
      username: username,
      password: password,
      roles: role
    });
    this.security.demoUsers.sort((a: { username: string; }, b: { username: any; }) => a.username.localeCompare(b.username));
    this.updateDirtyCheckList();

    //clear username, password & role
    this.security.demoUsername = this.security.demoUserPassword = this.security.demoUserRole = '';

  }

  updateDirtyCheckList() {
    if (isEqual(this.initialDemoUsers, this.security.demoUsers)) {
      this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('demoProvider', 1));
    } else if (!includes(this.security.dirtyCheckList, 'demoProvider')) {
      this.security.dirtyCheckList.push('demoProvider');
    }
  }


  //removes a demo user from existing demoUsers list
  removeDemoUser(name: any) {
    // TODO
    // deregister();
    // manually adding as the form dirty is not triggered on removing the user
    remove(this.security.demoUsers, { 'username': name });
    this.security.demoUsers.sort((a: { username: string; }, b: { username: any; }) => a.username.localeCompare(b.username));
    this.updateDirtyCheckList();
  }

  initConfig(provider: any) {
    this.security.demoUsername = this.security.demoUserPassword = this.security.demoUserRole = '';
    if (this.security.enableSecurity) {
      //hiding error messages if any, since provider was changed
      this.securityService.hideMessage(true);
    }
    this.security.showUnamePass = true;
    // TODO
    // this.handleWatchers(provider);
    //don't initialize if 'prevProvider' is same as 'provider'
    let demoProvider: any = find(this.authInfo.authProviders, { type: 'DEMO' });
    if(demoProvider) this.security.enableSecurityProvider = demoProvider.enabled;
    if (this.securityProps.prevProvider === provider) {
      return;
    }
    this.securityService.getDemoOptions(this.authInfo);
  }

  override ngOnDestroy(): void {
    this.resetFormSubscription?.unsubscribe();
  }
}
